var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.001,
    height: 9.999,
    viewBox: "0 0 34.001 9.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M-12173.257-9853.168H-12178v-1.666h4.752a5.049,5.049,0,0,1,4.967-4.165h2.28v10h-2.378A5.033,5.033,0,0,1-12173.257-9853.168Zm19.658,4.166h-2.4v-1h-5v-2h5v-4h-5v-2h5v-1h2.4a5.045,5.045,0,0,1,4.981,4.165h4.618v1.666h-4.624a5.031,5.031,0,0,1-4.878,4.166Z",
    transform: "translate(12178 9859)",
    fill: "#a1a1a1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/Disconnected.6e901bee29e472d3d82f32782f5ed7e6.svg";
export { ForwardRef as ReactComponent };